<template>
  <div>
  <v-dialog v-model="internalDialog" max-width="500px" scrollable>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card>
        <v-card-title class="justify-space-between">
        </v-card-title>
        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="6" class="text-left pt-10">
                <h3><strong>นัดหมายอีกครั้ง</strong></h3>
              </v-col>
              <v-col cols="6" class="pt-10">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-select
                  :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                    item-value="value"
                    v-model="fromAdd.masBranchID"
                    :items="branch"
                    :label="languageSelect === 0 ? 'สาขา *' : 'Branch *'"
                    outlined
                    required
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules ="[rules.required]"
                    @change="selectBranch()"
                >
                </v-select>
                <v-autocomplete
                v-if="(fromAdd.masBranchID !== '' && fromAdd.masBranchID !== null) && newCustomerStatus === false"
                  :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                  item-value="value"
                  v-model="fromAdd.flowId"
                  :items="DataFlowName"
                  :label="languageSelect === 0 ? (shopId === 'U5dc171850a89e6ca4bf5041c8725fdfe' ? 'ประเภทกิจกรรม *' : 'ประเภทบริการ') : 'Services *'"
                  outlined
                  required
                  :rules="[rules.required]"
                  dense
                  :menu-props="{ bottom: true, offsetY: true }"
                  @change="checkTitleEmp(),date = '', checkBrech(),clearconditionField(),priceMenu=0"
                >
                </v-autocomplete>
                <div>
                  <v-select
                    v-if="fromAdd.masBranchID !== '' && fromAdd.flowId !== ''"
                    :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                    item-value="value"
                    v-model="fromAdd.empId"
                    :items="dataEmp"
                    :label="languageSelect === 0 ? empTitleTh + ' *' : empTitleEng + ' *'"
                    outlined
                    required
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules ="[rules.required]"
                    @change="SetallowedDates(),fromAddTimeCus = '',checkCustomerTimeSlot(), date = ''"
                  >
                  </v-select>
                  <v-select
                    :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                    item-value="value"
                    v-if="customerTimeSlot === 'True' && fromAdd.empId !== '' && timeSlotbyCustomer.length > 1"
                    v-model="fromAddTimeCus"
                    :items="timeSlotbyCustomer"
                    :label="languageSelect === 0 ? 'จำนวนชั่วโมง *' : 'number of hours *'"
                    outlined
                    required
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules ="[rules.required]"
                    @change="date = '', AddallowedDatesBysetTimebyday()"
                  ></v-select>
                </div>
                <template v-if="BookingDataItemAgain">
                  <div
                    class="pa-0"
                    v-for="(item, index) in BookingDataItemAgain"
                    :key="index"
                  >
                    <template
                      v-if="
                        item.conditionField === '' ||
                          item.conditionField === null
                      "
                    >
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'text'"
                      >
                        <v-text-field
                          v-if="item.fieldName === 'เบอร์โทร'"
                          v-mask="'###-###-####'"
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                        <v-text-field
                          v-else
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'number'"
                      >
                        <v-text-field
                          v-if="item.fieldName === 'เบอร์โทร'"
                          v-mask="'###-###-####'"
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                        <v-text-field
                          v-else
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'dateTime'"
                      >
                        <v-menu
                          v-model="menuEdit1[item.fieldId]"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          :rules="[rules.required]"
                          transition="scale-transition"
                          offset-y
                          required
                          min-width="auto"
                          :ref="menuEdit1[item.fieldId]"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="item.fieldValue"
                              readonly
                              :label="item.fieldName"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              required
                              prepend-inner-icon="mdi-calendar"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.fieldValue"
                            no-title
                            scrollable
                            @input="
                              (menuEdit1[item.fieldId] = false),
                                $refs.menuEdit1[item.fieldId].save(item.fieldValue)
                            "
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Autocompletes'"
                      >
                        <v-autocomplete
                          v-model="item.fieldValue"
                          :items="JSON.parse(item.optionField)"
                          outlined
                          :label="item.fieldName"
                          required
                          dense
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Selects'"
                      >
                        <v-select
                          class="mb-6"
                          v-model="item.fieldValue"
                          :items="JSON.parse(item.optionField)"
                          menu-props="auto"
                          :label="item.fieldName"
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                          dense
                          clearable
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Radio'"
                        style="padding:0px;"
                      >
                        <v-container fluid style="padding:0px;">
                          <v-radio-group
                            column
                            dense
                            v-model="item.fieldValue"
                            style="margin:0px;"
                          >
                            <template v-slot:label> </template>
                            <div
                              v-for="radios in JSON.parse(
                                item.optionField
                              )"
                              :key="radios.toISOString"
                            >
                              <v-radio
                                :label="radios.text"
                                dense
                                :value="radios.value"
                              ></v-radio>
                            </div>
                          </v-radio-group>
                        </v-container>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Checkbox'"
                        style="padding: 0;"
                      >
                        <div>
                          <p
                            style="
                              text-align: left;
                              display: block;
                              font-size: 16px;
                              margin-bottom: 10px;
                            "
                          >
                            {{ item.fieldName }}
                          </p>
                          <div
                            v-for="(checkbox, index) in JSON.parse(item.optionField)"
                            :key="checkbox.text"
                          >
                            <v-container
                              fluid
                              class="pa-0 pt-0"
                              :class="{
                                'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                              }"
                            >
                              <span style="display: none;">{{ item.fieldValue }}</span>
                              <v-checkbox
                                v-model="selected[item.fieldId]"
                                :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                :value="checkbox.value"
                                :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                class="pt-1 mt-2 ps-3"
                              >
                              </v-checkbox>
                            </v-container>
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <template
                      v-if="
                        item.conditionField !== '' &&
                          BookingDataItemAgain.filter(row => {
                            return (
                              row.fieldId ===
                              parseInt(item.conditionField)
                            );
                          }).length > 0
                      "
                    >
                      <template
                        v-if="
                          item.conditionValue ===
                            BookingDataItemAgain.filter(row => {
                              return (
                                row.fieldId ===
                                parseInt(item.conditionField)
                              );
                            })[0].fieldValue
                        "
                      >
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'text'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            v-mask="'###-###-####'"
                            outlined
                            dense
                            required
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'number'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'dateTime'"
                        >
                          <v-menu
                            v-model="menuEdit2[item.fieldId]"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            :rules="[rules.required]"
                            transition="scale-transition"
                            offset-y
                            required
                            min-width="auto"
                            :ref="menuEdit2[item.fieldId]"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.fieldValue"
                                readonly
                                :label="item.fieldName"
                                outlined
                                dense
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.fieldValue"
                              no-title
                              scrollable
                              @input="
                                (menuEdit2[item.fieldId] = false),
                                  $refs.menuEdit2[item.fieldId].save(item.fieldValue)
                              "
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Autocompletes'"
                        >
                          <v-autocomplete
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            outlined
                            :label="item.fieldName"
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Selects'"
                        >
                          <v-select
                            class="mb-6"
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            menu-props="auto"
                            :label="item.fieldName"
                            required
                            dense
                            clearable
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Radio'"
                          style="padding:0px;"
                        >
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              dense
                              v-model="item.fieldValue"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              style="margin:0px;"
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(
                                  item.optionField
                                )"
                                :key="radios.toISOString"
                              >
                                <v-radio
                                  :label="radios.text"
                                  :value="radios.value"
                                  dense
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Checkbox'"
                          style="padding: 0;"
                        >
                          <div>
                            <p
                              style="
                                text-align: left;
                                display: block;
                                font-size: 16px;
                                margin-bottom: 10px;
                              "
                            >
                              {{ item.fieldName }}
                            </p>
                            <div
                              v-for="(checkbox, index) in JSON.parse(item.optionField)"
                              :key="checkbox.text"
                            >
                              <v-container
                                fluid
                                class="pa-0 pt-0"
                                :class="{
                                  'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                  'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                                }"
                              >
                                <span style="display: none;">{{ item.fieldValue }}</span>
                                <v-checkbox
                                  v-model="selected[item.fieldId]"
                                  :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                  :value="checkbox.value"
                                  :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                  @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                  class="pt-1 mt-2 ps-3"
                                >
                                </v-checkbox>
                              </v-container>
                            </div>
                          </div>
                        </v-col>
                      </template>
                    </template>
                    <template v-if="item.conditionField === 'flow'">
                      <template
                        v-if="
                          parseInt(item.conditionValue) ===
                            parseInt(formEditBooking.flowId)
                        "
                      >
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'text'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'number'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'dateTime'"
                        >
                          <v-menu
                            v-model="menuEdit3[item.fieldId]"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            :rules="[rules.required]"
                            transition="scale-transition"
                            offset-y
                            required
                            min-width="auto"
                            :ref="menuEdit3[item.fieldId]"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.fieldValue"
                                readonly
                                :label="item.fieldName"
                                outlined
                                dense
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.fieldValue"
                              no-title
                              scrollable
                              @input="
                                (menuEdit3[item.fieldId] = false),
                                  $refs.menuEdit3[item.fieldId].save(item.fieldValue)
                              "
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Autocompletes'"
                        >
                          <v-autocomplete
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            dense
                            filled
                            :label="item.fieldName"
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Selects'"
                        >
                          <v-select
                            class="mb-6"
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            menu-props="auto"
                            :label="item.fieldName"
                            dense
                            clearable
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            hide-details
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="item.fieldValue"
                              style="margin:0px;"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(
                                  item.optionField
                                )"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </v-col>
                      </template>
                    </template>
                  </div>
                </template>
                <v-row>
                    <v-col class="pb-0" :cols="showTime === 'แสดง' && date !== ''? 6 : 12">
                      <div v-if="(customerTimeSlot === 'False' ? fromAdd.empId : fromAddTimeCus) && newCustomerStatus === false">
                        <!-- <div v-if="fromAdd.masBranchID && fromAdd.flowId"> -->
                        <v-menu
                        ref="menu"
                        v-model="menuDate"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        :rules="[rules.required]"
                        transition="scale-transition"
                        offset-y
                        top
                        required
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date"
                            :label="languageSelect === 0 ? 'วันที่' : 'Date'"
                            readonly
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            required
                            @click="pickerDate ? getMonth(pickerDate) : null"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label
                              >{{ languageSelect === 0 ? dateBookingTextThai() : dateBookingTextEng() }}
                            </template>
                            <template #prepend-inner>
                              <v-icon
                                right
                              >
                                mdi-calendar
                              </v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <!-- <div class="text-center">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        </div> -->
                        <v-date-picker
                          v-model="date"
                          no-title
                          scrollable
                          :allowed-dates="allowedDates"
                          :picker-date.sync="pickerDate"
                          @change="setLimitBooking(date)"
                          @input="(menuDate = false), $refs.menu.save(date)"
                          :min="currentDate"
                        >
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col class="pb-0" v-if="(showTime === 'แสดง') && newCustomerStatus === false" cols="6">
                    <v-select
                      v-model="time"
                      :items="timeavailable"
                      :label="languageSelect === 0 ? 'เวลา' : 'Time'"
                      item-text="text"
                      item-value="text"
                      persistent-hint
                      return-object
                      outlined
                      required
                      v-if="showTime === 'แสดง' && date !== ''"
                      :rules="[rules.required]"
                      :menu-props="{ top: true, offsetY: true }"
                    >
                      <template v-slot:label
                        >{{ languageSelect === 0 ? "เวลา *" : "Time *" }}
                      </template></v-select
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
                elevation="2"
                color="#173053"
                dark
                large
                block
                @click="addBooking()"
                >นัดหมายอีกครั้ง</v-btn
              >
        </v-card-actions>
      </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'AddBookingAgain',
  props: {
    refId: {
      type: String,
      required: true
    },
    typeBookingAgain: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      overlay: false,
      internalDialog: this.value,
      shopId: this.$session.getAll().data.shopId,
      languageSelect: 0,
      valid: true,
      rules: {
        checkBox: value => {
          // value อาจเป็น undefined / '' ถ้ายังไม่เคยติ๊ก จึงต้องกันไว้ก่อน
          if (!Array.isArray(value) || value.length < 1) {
            return 'กรุณากรอกข้อมูลอย่างน้อย 1 รายการ'
          }
          return true
        },
        numberType: value => {
          if (isNaN(value)) {
            return 'กรุณากรอกตัวเลขเท่านั้น'
          }

          const parsedValue = parseFloat(value)
          if (!Number.isInteger(parsedValue)) {
            return 'กรุณากรอกตัวเลขเท่านั้น'
          }

          return true
        },
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || '',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      menuDate: false,
      fromAdd: {
        bookingFieldId: null,
        bookingDataCustomerEmail: '',
        fieldId: '',
        fieldValue: '',
        flowId: '',
        masBranchID: '',
        empId: '',
        dueDate: '',
        shopId: '',
        userId: '',
        packageId: '',
        tokenPackage: '',
        statusUpload1: 'False',
        statusUpload2: 'False',
        fileUpload1: '',
        fileUpload2: '',
        bookingLanguage: 0
      },
      selected: {},
      timeavailable: null,
      currentDate: moment().format('YYYY-MM-DD'),
      currentMonth: moment().format('YYYY-MM'),
      pickerDate: null,
      activePicker: null,
      time: '',
      date: '',
      showTime: '',
      dueDate: '',
      dueDateItems: [],
      checkLimitBooking: {
        ID: '',
        countBooking: null,
        limitCheck: null,
        limitBooking: 0,
        timeSelect: [],
        timeBooking: [],
        slotByflow: ''
      },
      dateDayoff: [],
      dateDayCustom: [],
      dateDaylimit: null,
      limitBookingCheck: false,
      EmpItemLimit: [],
      dataEmp: [],
      dataEmpAll: [],
      showTable: [],
      empTitleTh: '',
      empTitleEng: '',
      timeSlotbyCustomer: [],
      fromAddTimeCus: '',
      customerTimeSlot: 'False',
      dataBookingAgain: [],
      branch: [],
      branchData: [],
      BookingDataItemAgain: [],
      DataFlowNameAll: [],
      DataFlowName: [],
      newCustomerStatus: false
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
      if (val) {
        this.buildData()
      }
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    },
    pickerDate (newval, oldval) {
      this.getMonth(newval)
      // this.allowedDates()
      // here you can check if month changed using newval and oldval
    }
  },
  methods: {
    close () {
      this.internalDialog = false
    },
    async buildData () {
      this.overlay = true
      await this.clearData()
      await this.getBookingView()
      await this.getDataBranch()
      await this.buildDataCustomField()
      console.log('this.dataBookingAgain[0]', this.dataBookingAgain[0])
      this.fromAdd.masBranchID = parseInt(this.dataBookingAgain[0].masBranchID)
      await this.selectBranch()
      this.fromAdd.flowId = parseInt(this.dataBookingAgain[0].flowId)
      this.languageSelect = parseInt(this.dataBookingAgain[0].bookingLanguage)
      await this.checkTitleEmp()
      await this.getEmp()
      this.fromAdd.empId = parseInt(this.dataBookingAgain[0].bookingEmpFlow)
      await this.SetallowedDates()
      this.overlay = false
    },
    async clearData () {
      this.menuDate = false
      this.fromAdd = {
        bookingFieldId: null,
        bookingDataCustomerEmail: '',
        fieldId: '',
        fieldValue: '',
        flowId: '',
        masBranchID: '',
        empId: '',
        dueDate: '',
        shopId: '',
        userId: '',
        packageId: '',
        tokenPackage: '',
        statusUpload1: 'False',
        statusUpload2: 'False',
        fileUpload1: '',
        fileUpload2: ''
      }
      this.selected = {}
      this.timeavailable = null
      this.currentDate = moment().format('YYYY-MM-DD')
      this.currentMonth = moment().format('YYYY-MM')
      this.pickerDate = null
      this.activePicker = null
      this.time = ''
      this.date = ''
      this.showTime = ''
      this.dueDate = ''
      this.dueDateItems = []
      this.checkLimitBooking = {
        ID: '',
        countBooking: null,
        limitCheck: null,
        limitBooking: 0,
        timeSelect: [],
        timeBooking: [],
        slotByflow: ''
      }
      this.dateDayoff = []
      this.dateDayCustom = []
      this.dateDaylimit = null
      this.limitBookingCheck = false
      this.EmpItemLimit = []
      this.dataEmp = []
      this.dataEmpAll = []
      this.showTable = []
      this.empTitleTh = ''
      this.empTitleEng = ''
      this.timeSlotbyCustomer = []
      this.fromAddTimeCus = ''
      this.customerTimeSlot = 'False'
      this.dataBookingAgain = []
      this.branch = []
      this.branchData = []
      this.BookingDataItemAgain = []
      this.DataFlowNameAll = []
      this.DataFlowName = []
      this.newCustomerStatus = false
    },
    async getBookingView () {
      try {
        this.dataBookingAgain = []
        if (this.typeBookingAgain === 'job') {
          let response = await axios.get(this.$DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&jobNo=' + this.refId)
          if (response.data.length > 0) {
            this.dataBookingAgain = response.data
          }
        } else {
          let response = await axios.get(this.$DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&bookNo=' + this.refId)
          if (response.data.length > 0) {
            this.dataBookingAgain = response.data
          }
        }
      } catch (error) {
        this.dataBookingAgain = []
      }
    },
    async getDataBranch () {
      this.branch = []
      this.branchData = []
      await axios.get(this.$DNS_IP + '/master_branch/get?shopId=' + this.shopId).then(async (response) => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let s = {}
            s.text = d.masBranchName
            s.textEng = d.masBranchNameEn
            s.value = d.masBranchID
            this.branch.push(s)
            this.branchData.push(d)
          }
        }
      })
    },
    async buildDataCustomField () {
      try {
        this.BookingDataItemAgain = []
        let itemIncustomField = []
        console.log('buildDataCustomField----', this.dataBookingAgain[0])
        await axios.get(this.$DNS_IP + '/BookingField/get?shopId=' + this.dataBookingAgain[0].shopId)
          .then(async resBookingField => {
            let dataBookingField = resBookingField.data
            this.fromAdd.bookingFieldId = dataBookingField[0].bookingFieldId
            if (dataBookingField.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(dataBookingField[0].flowfieldName)
              if (dataBookingField[0].showTime === null || dataBookingField[0].showTime === '') {
                this.showTime = 'แสดง'
              } else {
                this.showTime = dataBookingField[0].showTime
              }
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                  '/customField/fieldId?fieldId=' +
                  itemIncustomField
                )
                .then(async resCustomField => {
                  let dataCustomField = resCustomField.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + this.dataBookingAgain[0].bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      console.log('BookingDataSelect', rs)
                      if (rs.length > 0) {
                        let sortrs = dataCustomField.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (var i = 0; i < sortrs.length; i++) {
                          var d = sortrs[i]
                          var s = {}
                          var dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          // console.log('dataBD', dataBD)
                          if (dataBD.length > 0) {
                            s.bookNo = dataBD[0].bookNo
                            s.bookingFieldId = dataBookingField[0].bookingFieldId
                            s.bookingDataId = dataBD[0].bookingDataId
                            s.conditionField = d.conditionField
                            s.fieldId = d.fieldId
                            s.fieldType = d.fieldType
                            if (d.fieldType === 'Checkbox') {
                              console.log('checkbox')
                              this.selected[d.fieldId] = this.parseCheckboxValue(dataBD[0].fieldValue)
                            }
                            s.fieldValue = dataBD[0].fieldValue
                            s.fieldName = d.fieldName
                            s.conditionField = d.conditionField
                            s.conditionValue = d.conditionValue
                            s.requiredField = d.requiredField
                            s.optionField = d.optionField
                            s.shopId = d.shopId
                            this.BookingDataItemAgain.push(s)
                          } else {
                            s.bookNo = rs[0].bookNo
                            s.bookingFieldId = dataBookingField[0].bookingFieldId
                            s.bookingDataId = 'newDataBooking'
                            s.conditionField = d.conditionField
                            s.fieldId = d.fieldId
                            s.fieldType = d.fieldType
                            s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                            s.fieldName = d.fieldName
                            s.conditionField = d.conditionField
                            s.conditionValue = d.conditionValue
                            s.requiredField = d.requiredField
                            s.optionField = d.optionField
                            s.shopId = d.shopId
                            this.BookingDataItemAgain.push(s)
                          }
                        }
                      } else {
                        let sortrs = dataCustomField.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          let s = {}
                          // let dataBD = rs.filter(el => { return parseInt(el.fieldId) === parseInt(d.fieldId) })
                          // console.log('dataBD', dataBD)
                          // if (dataBD.length > 0) {
                          s.bookNo = this.dataBookingAgain[0].bookNo
                          s.bookingFieldId = dataBookingField[0].bookingFieldId
                          s.bookingDataId = 'newDataBooking'
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          s.shopId = d.shopId
                          this.BookingDataItemAgain.push(s)
                        // }
                        }
                      }
                    })
                    .catch(error => {
                      this.$swal(
                        'พบความผิดพลาดระหว่างดำเนินการ',
                        'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                        'info'
                      )
                        .then(result => {
                          this.internalDialog = false
                        })
                        .catch(error => {
                          console.log('error function setDataEdit : ', error)
                          this.internalDialog = false
                        })
                      console.log('error function setDataEdit : ', error)
                    })
                })
            } else {
              this.$swal(
                'พบความผิดพลาดระหว่างดำเนินการ',
                'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                'info'
              )
                .then(result => {
                  this.internalDialog = false
                })
                .catch(error => {
                  console.log('error function setDataEdit : ', error)
                  this.internalDialog = false
                })
            }
          })
          .catch(error => {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.internalDialog = false
              })
              .catch(error => {
                console.log('error function setDataEdit : ', error)
                this.internalDialog = false
              })
            console.log('error function setDataEdit : ', error)
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async selectBranch () {
      this.fromAdd.flowId = ''
      this.date = ''
      this.customerTimeSlot = 'False'
      await this.getDataFlow()
    },
    async getDataFlow () {
      this.DataFlowName = []
      this.DataFlowNameAll = []
      let dataFlowName = []
      let dataFlowNameAll = []
      await axios.get(this.$DNS_IP + '/flow/get?shopId=' + this.shopId + '&isShow=all').then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let checkBranchByFlow = d.masBranchID || 'All'
            if ((checkBranchByFlow === this.fromAdd.masBranchID.toString()) || checkBranchByFlow === 'All') {
              if (d.timeSlotStatus === 'True') {
                let s = {}
                s.text = d.flowName
                s.textEng = d.flowNameEn
                s.value = d.flowId
                dataFlowName.push(s)
                dataFlowNameAll.push(d)
              }
            }
          }
          this.DataFlowName = dataFlowName
          this.DataFlowNameAll = dataFlowNameAll
        } else {
          this.DataFlowName = []
          this.DataFlowNameAll = []
        }
      })
    },
    checkTitleEmp () {
      this.customerTimeSlot = 'False'
      let checkDataEmpTitle = this.DataFlowNameAll.filter(el => { return el.flowId === this.fromAdd.flowId })
      // console.log('------------------------->>>>>>>>', checkDataEmpTitle)
      if (checkDataEmpTitle.length > 0) {
        this.empTitleTh = checkDataEmpTitle[0].empTitleTh || 'พนักงานช่าง'
        this.empTitleEng = checkDataEmpTitle[0].empTitleEng || 'Employee'
      } else {
        this.empTitleTh = 'พนักงานช่าง'
        this.empTitleEng = 'Employee'
      }
    },
    clearconditionField () {
      // let nameConditionField = []
      this.BookingDataItemAgain.forEach((item) => {
        if (item.conditionField !== null && item.conditionField !== '') {
          item.fieldValue = ''
        }
      })
    },
    async checkBrech () {
      if (this.fromAdd.masBranchID !== '') {
        this.fromAdd.empId = ''
        await this.getEmp()
      } else {
        this.fromAdd.masBranchID = ''
      }
    },
    async getEmp () {
      this.fromAdd.empId = ''
      this.dataEmp = []
      this.dataEmpAll = []
      this.EmpItemLimit = []
      await axios.get(this.$DNS_IP + '/empSelect/get?privacyPage=bookingform&masBranchID=' + this.fromAdd.masBranchID).then(async (response) => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.flowId !== null && d.flowId !== '') {
              let checkFlowId = JSON.parse(d.flowId)
              if (checkFlowId.filter((a) => parseInt(a) === this.fromAdd.flowId).length > 0) {
                if (d.setTime !== null && d.setTime !== '[]' && d.setTime !== '') {
                  let s = {}
                  s.text = d.empFull_NameTH
                  s.textEng = d.empFull_NameTH
                  s.value = d.empId
                  s.creditpackage = d.credit_package
                  this.dataEmp.push(s)
                  this.dataEmpAll.push(d)
                  let limit = {}
                  limit.empId = d.empId
                  limit.limitBookingCheck = d.limitBookingCheck || 'False'
                  limit.setTime = d.setTime || '[]'
                  limit.setTimebyday = d.setTimebyday
                  this.EmpItemLimit.push(limit)
                  console.log('EmpItemLimit', this.EmpItemLimit)
                }
              }
            }
          }
        } else {
          this.dataEmp = []
          this.dataEmpAll = []
          this.EmpItemLimit = []
        }
      })
      await this.checkEmpData()
    },
    async checkEmpData () {
      if (this.dataEmp.length === 0) {
        this.$swal(
          this.languageSelect === 0 ? 'ไม่มี' + this.empTitleTh + 'สำหรับประเภทบริการนี้' : 'There is no ' + this.empTitleEng + ' for this type of service.',
          this.languageSelect === 0 ? 'กรุณาเลือกประเภทบริการอื่นๆ' : 'Please select another type of service.',
          'info'
        )
      }
      if (this.dataEmp.length === 1) {
        this.fromAdd.empId = this.dataEmp[0].value
        await this.SetallowedDates()
        await this.checkCustomerTimeSlot()
      }
    },
    async SetallowedDates () {
      this.dataEmpAll.forEach((v, k) => {
        if (v.empId === this.fromAdd.empId) {
          v.dateDayCustom = v.dateDayCustom || ''
          v.dateDayoffValue = v.dateDayoffValue || ''
          if (v.dateDayoffValue !== '') {
            this.dateDayoff = JSON.parse(v.dateDayoffValue)
          } else {
            this.dateDayoff = []
          }
          if (v.dateDayCustom !== '') {
            this.dateDayCustom = JSON.parse(v.dateDayCustom)
          } else {
            this.dateDayCustom = []
          }
        }
      })
      if (this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId).length > 0) {
        let bookingNowCheck = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheck || ''
        if (bookingNowCheck === 'True') {
          let bookingNowCheckCount = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheckCount || 1
          this.currentDate = moment().add(bookingNowCheckCount, 'days').format('YYYY-MM-DD')
        } else {
          this.currentDate = moment().format('YYYY-MM-DD')
        }
      }
    },
    allowedDates (val) {
      if (this.dateDaylimit) {
        if (this.dataEmpAll.filter(el => el.empId === this.fromAdd.empId)[0].typeDayCustom === 'on') {
          return val === this.dateDayCustom.filter(el => el === val)[0]
        } else {
          if (
            this.dateDayoff.filter(el => {
              return el === moment(val).day()
            }).length === 0 &&
          this.dateDayCustom.filter(el => {
            return el === val
          }).length === 0 &&
          this.dateDaylimit.filter(el => {
            return el === val
          }).length === 0
          ) {
            return val
          }
        }
      }
    },
    checkCustomerTimeSlot () {
      this.timeSlotbyCustomer = []
      this.customerTimeSlot = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].customerTimeSlot
      let timeSLOT = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].timeSlot
      let coutTimeSlot = 1
      let allTime = []
      if (this.customerTimeSlot === 'True') {
        let setTime = []
        // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
        if (this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].setTimebyday === 'True') {
          let timeJson = JSON.parse(this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].setTime)
          let dataTime = []
          timeJson.forEach((itemTime, index) => {
            // console.log('item', itemTime)
            allTime = itemTime.setTime
            allTime.forEach((item, key) => {
              let ss = {}
              if (allTime.length === 1) {
                ss.text = 'ไม่ระบุ (มีเวลาเดียว)'
                ss.value = key + 1
                dataTime.push(ss)
              } else {
                if (key > 0) {
                  let start = allTime.filter((i, k) => k === 0)[0].value
                  let end = item.value
                  ss.text = this.calculateTime(start, end)
                  ss.textEng = this.calculateTimeEng(start, end)
                  ss.value = key
                  if (coutTimeSlot === timeSLOT) {
                    dataTime.push(ss)
                    coutTimeSlot = 1
                  } else {
                    coutTimeSlot = coutTimeSlot + 1
                  }
                  // this.timeSlotbyCustomer.push(ss)
                }
              }
              if ((key + 1) === allTime.length) {
                coutTimeSlot = 1
              }
            })
          })
          dataTime.forEach((i, n) => {
            if (this.timeSlotbyCustomer.filter((item) => item.text === i.text && item.value === i.value).length === 0) {
              this.timeSlotbyCustomer.push(i)
            }
          })
        } else {
          setTime = JSON.parse(this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].setTime) || []
          allTime = setTime
          allTime.forEach((item, key) => {
            let ss = {}
            if (allTime.length === 1) {
              this.fromAddTimeCus = key + 1
            } else {
              if (key > 0) {
                let start = allTime.filter((i, k) => k === 0)[0].value
                let end = item.value
                ss.text = this.calculateTime(start, end)
                ss.textEng = this.calculateTimeEng(start, end)
                ss.value = key
                if (coutTimeSlot === timeSLOT) {
                  this.timeSlotbyCustomer.push(ss)
                  coutTimeSlot = 1
                } else {
                  coutTimeSlot = coutTimeSlot + 1
                }
              }
            }
          })
        }
      }
    },
    calculateTime (start, end) {
      let countTime = null
      // if (end > start) {
      //   let time = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
      //   let h = parseInt(time.split(':')[0])
      //   let m = parseInt(time.split(':')[1])
      //   countTime = (h * 60) + m
      // } else {
      //   countTime = 0
      // }
      if (end > start) {
        let genTime = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
        let h = parseInt(genTime.split(':')[0])
        let m = parseInt(genTime.split(':')[1])
        if (h === 0 && m !== 0) {
          countTime = m + ' นาที'
        } else if (h !== 0 && m === 0) {
          countTime = h + ' ชม.'
        } else {
          countTime = h + ' ชม. ' + m + ' นาที'
        }
      } else {
        countTime = 'No Data'
      }
      return countTime
    },
    calculateTimeEng (start, end) {
      let countTime = null
      // if (end > start) {
      //   let time = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
      //   let h = parseInt(time.split(':')[0])
      //   let m = parseInt(time.split(':')[1])
      //   countTime = (h * 60) + m
      // } else {
      //   countTime = 0
      // }
      if (end > start) {
        let genTime = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
        let h = parseInt(genTime.split(':')[0])
        let m = parseInt(genTime.split(':')[1])
        if (h === 0 && m !== 0) {
          countTime = m + ' min.'
        } else if (h !== 0 && m === 0) {
          countTime = h + ' h.'
        } else {
          countTime = h + ' h. ' + m + ' min.'
        }
      } else {
        countTime = 'No Data'
      }
      return countTime
    },
    async getMonth (month) {
      const result = await axios.get(this.$DNS_IP + '/LimitBookingDate/get_LimitDate?shopId=' + this.shopId + '&flowId=' + this.fromAdd.flowId + '&bookingDate=' + month)
      if (result.data.length > 0) {
        console.log('getMonth IF', result.data)
        this.dateDaylimit = []
        let dt = result.data
        if (dt[0].limitBookingCheck === 'True') {
          dt.forEach((v, k) => {
            if (JSON.parse(v.setTime)) {
              let count = 0
              JSON.parse(v.setTime).forEach((v2, k2) => {
                count += parseInt(v2.limitBooking)
              })
              if (v.sum >= count) {
                this.dateDaylimit.push(
                  moment(v.bookingDate).format('YYYY-MM-DD')
                )
              }
            }
          })
        } else {
          this.dateDaylimit = []
        }
      } else {
        this.dateDaylimit = []
      }
    },
    dateBookingTextThai () {
      let textThai = ''
      if (this.shopId === 'U9f316c85400fd716ea8c80d7cd5b61f8') {
        textThai = 'วันที่เข้ารับบริการ *'
      } else {
        textThai = 'วันที่ *'
      }
      return textThai
    },
    dateBookingTextEng () {
      let textThai = ''
      if (this.shopId === 'U9f316c85400fd716ea8c80d7cd5b61f8') {
        textThai = 'Date of service *'
      } else {
        textThai = 'Date *'
      }
      return textThai
    },
    async setLimitBooking (dateitem) {
      this.time = ''
      this.timeavailable = []
      // this.showTable = []
      let getDayNumber = moment(dateitem).day()
      let filterEmpItemLimit = this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })
      let setTime = []
      // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
      if (filterEmpItemLimit[0].setTimebyday === 'True') {
        let timeJson = JSON.parse(filterEmpItemLimit[0].setTime).filter((items) => items.value === getDayNumber)
        setTime = timeJson[0].setTime || []
      } else {
        setTime = JSON.parse(filterEmpItemLimit[0].setTime) || []
      }
      this.limitBookingCheck = filterEmpItemLimit[0].limitBookingCheck || 'False'
      if (this.limitBookingCheck === 'True') {
        this.timeavailable = setTime
        let slotByflow = []
        if (this.customerTimeSlot === 'False') {
          slotByflow = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].timeSlot
        } else {
          slotByflow = this.fromAddTimeCus
        }
        let overTime = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].overTime
        if (this.timeavailable.length >= slotByflow) {
          let LimitBooking = await this.getLimitBooking()
          // เซ็ต Status True ให้แต่ละช่วงเวลา
          this.timeavailable.forEach((v, k) => {
            if (typeof v.status === 'undefined') {
              v.status = true
              if (v.limitBooking === '0') {
                v.status = false
              }
            }
          })
          // เซ็ต Status False ให้กับช่วงเวลาที่มีคนจองแล้ว
          if (LimitBooking.status !== false) {
            if (LimitBooking.length > 0) {
              this.timeavailable.forEach((v, k) => {
                let bookingTarget = LimitBooking.filter((a) => a.bookingTime === v.value)
                if (bookingTarget.length > 0) {
                  v.status = false
                  let bookingTargetSlot = bookingTarget[0].timeSlotCustomer || bookingTarget[0].timeSlot
                  for (let bT = 0; bT < bookingTargetSlot; bT++) {
                    if (this.timeavailable[k + bT] !== undefined) {
                      this.timeavailable[k + bT].status = false
                    }
                  }
                }
              })
            }
          }
          // จับคู่เวลาตาม slotbyFlow
          let Newtimeavailable = []
          let slotCheck = slotByflow
          for (let i = 0; i < this.timeavailable.length; i++) {
            let num = i + (slotCheck - 1)
            let checkitem = this.timeavailable.filter((item, key) => (key >= i && key <= num))
            Newtimeavailable.push(checkitem)
          }
          this.timeavailable = []

          //  ตัดเวลาที่มีค่า False ออก
          Newtimeavailable.forEach((v, k) => {
            if (overTime === 'True') {
              if (v.filter((v) => v.status === false).length <= 0) {
                this.timeavailable.push(v[0])
              }
            } else {
              console.log('else')
              // ปิดเวลาสุดท้ายในกรณีที่ ไม่ต้องการให้จองเลยเวลา
              if (v.filter((v) => v.status === false).length <= 0 && v.length >= slotCheck) {
                this.timeavailable.push(v[0])
              }
            }
          })
          this.GetbookingNowCheck()
          // ตัดเวลาในกรณีที่เป็นวันปัจจุบัน เพื่อตัดเวลาที่ผ่านมาแล้วออก
          let bookingNowCheck = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheck
          // let bookingNowCheckCount = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheckCount || 1
          let bookingNowCheckTimeStatus = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheckTimeStatus || 'False'
          let currentDateBybookingNowCheckTimeStatus = moment().format('YYYY-MM-DD')
          if (bookingNowCheck === 'True' && bookingNowCheckTimeStatus === 'True') {
            currentDateBybookingNowCheckTimeStatus = this.currentDate
          }
          if (moment(dateitem).format('YYYY-MM-DD') === moment(currentDateBybookingNowCheckTimeStatus).format('YYYY-MM-DD')) {
            this.timeavailable = this.timeavailable.filter(item => moment().format(item.value) > moment().format('HH:mm'))
          } else {
          }
          if (this.timeavailable.length === 0) {
            this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
            this.date = ''
          }
          if (this.timeavailable.length === 1) {
            this.time = this.timeavailable[0]
          }
        } else {
          this.timeavailable = []
          this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
            .then(() => { this.date = '' }).catch(() => { this.date = '' })
        }
      } else {
        // LimitBookingBy Flow
        this.timeavailable = setTime
        if (this.timeavailable.length === 1) {
          this.time = this.timeavailable[0]
        }
      }
    },
    async getLimitBooking () {
      let LimitBooking = axios.get(this.$DNS_IP + '/LimitBookingDateEmp/get?shopId=' + this.shopId + '&empId=' + this.fromAdd.empId + '&bookingDate=' + this.date).then(async (response) => {
        let rs = response.data
        return rs
      })
      return LimitBooking
    },
    async GetbookingNowCheck () {
      let bookingNowCheck = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheck
      let bookingNowCheckCount = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheckCount || 1
      let bookingNowCheckTimeStatus = this.DataFlowNameAll.filter((v) => v.flowId === this.fromAdd.flowId)[0].bookingNowCheckTimeStatus || 'False'
      console.log('bookingNowCheckTimeStatus', bookingNowCheck, bookingNowCheckCount, bookingNowCheckTimeStatus)
      if (bookingNowCheck === 'True') {
        let CheckMonth = moment().add(bookingNowCheckCount, 'days').format('YYYY-MM')
        // console.log('CheckMonth', CheckMonth)
        if (CheckMonth !== this.currentMonth) {
          this.next_bookingNowCheckCount_month = 'True'
          this.setMonthCarousel_Check('next_bookingNowCheckCount_month')
        } else {
          this.next_bookingNowCheckCount_month = 'False'
        }
        this.currentDate = moment().add(bookingNowCheckCount, 'days').format('YYYY-MM-DD')
        this.currentMonth = moment(this.currentDate, 'YYYY-MM').format('YYYY-MM')
      } else {
        this.currentDate = moment().format('YYYY-MM-DD')
      }
    },
    async AddallowedDatesBysetTimebyday () {
      await this.SetallowedDates()
      if (this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].setTimebyday === 'True') {
        let timeJson = JSON.parse(this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].setTime)
        timeJson.forEach((item) => {
          if (item.setTime.length < this.fromAddTimeCus) {
            if (this.dateDayoff.filter((i) => i === item.value).length === 0) {
              this.dateDayoff.push(item.value)
            }
          }
        })
      }
    },
    async checkLimit () {
      this.checkLimitBooking.ID = 'NO'
      this.checkLimitBooking.countBooking = 1
      let LimitBooking = await this.getLimitBooking()
      if (LimitBooking.status === false) {
        this.checkLimitBooking.ID = 'NO'
        this.checkLimitBooking.countBooking = 1
        // let allBookingTime = []
        let getDayNumber = moment(this.date).day()
        let filterEmpItemLimit = this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })
        let dt = []
        if (filterEmpItemLimit[0].setTimebyday === 'True') {
          let timeJson = JSON.parse(filterEmpItemLimit[0].setTime).filter((items) => items.value === getDayNumber)
          dt = timeJson[0].setTime || []
        } else {
          dt = JSON.parse(filterEmpItemLimit[0].setTime) || []
        }
        let checkTimeSlot = []
        let index = dt.findIndex((i, k) => i.value === this.time.value)
        let slot = ''
        if (this.customerTimeSlot === 'False') {
          slot = this.DataFlowNameAll.filter((item) => item.flowId === this.fromAdd.flowId)[0].timeSlot
        } else {
          slot = this.fromAddTimeCus
        }
        let num = index + (slot - 1)
        checkTimeSlot = dt.filter((i, k) => (k >= index && k <= num))
        this.checkLimitBooking.limitCheck = 'true'
        this.checkLimitBooking.limitBooking = 1
        this.checkLimitBooking.timeSelect = checkTimeSlot
        this.checkLimitBooking.timeBooking = dt
        this.checkLimitBooking.slotByflow = slot
      } else {
        let allBookingTime = []
        let getDayNumber = moment(this.date).day()
        let filterEmpItemLimit = this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })
        let dt = []
        if (filterEmpItemLimit[0].setTimebyday === 'True') {
          let timeJson = JSON.parse(filterEmpItemLimit[0].setTime).filter((items) => items.value === getDayNumber)
          dt = timeJson[0].setTime || []
        } else {
          dt = JSON.parse(filterEmpItemLimit[0].setTime) || []
        }
        LimitBooking.forEach((item, key) => {
          if (dt.filter((i, k) => i.value === item.bookingTime).length > 0) {
            let index = dt.findIndex((i, k) => i.value === item.bookingTime)
            let slot = item.timeSlotCustomer || item.timeSlot
            let num = index + (slot - 1)
            allBookingTime.push(dt.filter((i, k) => (k >= index && k <= num)))
          }
        })
        let checkTimeSlot = []
        let index = dt.findIndex((i, k) => i.value === this.time.value)
        let slot = ''
        if (this.customerTimeSlot === 'False') {
          slot = this.DataFlowNameAll.filter((item) => item.flowId === this.fromAdd.flowId)[0].timeSlot
        } else {
          slot = this.fromAddTimeCus
        }
        let num = index + (slot - 1)
        checkTimeSlot = dt.filter((i, k) => (k >= index && k <= num))
        this.checkLimitBooking.limitCheck = 'true'
        this.checkLimitBooking.limitBooking = 1
        this.checkLimitBooking.timeSelect = checkTimeSlot
        this.checkLimitBooking.timeBooking = dt
        this.checkLimitBooking.slotByflow = slot
        checkTimeSlot.forEach((item, key) => {
          allBookingTime.forEach((item2, key2) => {
            // console.log('filter', item2.filter((i, n) => i.value === item.value))
            if (item2.filter((i, n) => i.value === item.value).length > 0) {
              this.checkLimitBooking.limitCheck = 'false'
            } else {
            }
          })
        })
      }
      // console.log('this.checkLimitBooking', this.checkLimitBooking)
    },
    async addBooking () {
      const isValid = this.$refs.form.validate()
      console.log('this.BookingDataItemAgain', this.BookingDataItemAgain)
      if (isValid) {
        this.addBookingStepTwo()
      }
    },
    async addBookingStepTwo () {
      if (this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].limitBookingCheck === 'True') {
        await this.checkLimit()
        // console.log('test', this.branchData.filter(item => { return item.masBranchID === this.fromAdd.masBranchID })[0].setTime)
        if (this.checkLimitBooking.limitCheck === 'true') {
          await this.addBookingsubmit('True')
        } else if (this.checkLimitBooking.limitCheck === 'false') {
          this.$swal(
            this.languageSelect === 0 ? 'มีลูกค้าท่านอื่นนัดหมายเวลานี้แล้ว' : 'There are other customers making appointments at this time.',
            this.languageSelect === 0 ? 'กรุณาเลือกวันที่ / เวลา ใหม่อีกครั้ง' : 'Please select a new date/time again.',
            'info'
          )
          this.date = ''
          this.time = ''
        } else {
          await this.addBookingsubmit('True')
        }
      } else {
        await this.addBookingsubmit('False')
      }
    },
    async addBookingsubmit (limitBookingCheck) {
      let rs = this.BookingDataItemAgain
      let Add = []
      let fielditem = this.BookingDataItemAgain
      var dueDate = ''
      if (this.showTime === 'แสดง') {
        dueDate = this.date + ' ' + this.time.value
      } else {
        dueDate = this.date
      }
      let userId = this.dataBookingAgain[0].userId || 'user-skip'
      for (let i = 0; i < rs.length; i++) {
        let d = rs[i]
        let update = {}
        if (d.conditionField === '' || d.conditionField === null) {
          update.masBranchID = this.fromAdd.masBranchID
          update.bookingFieldId = this.fromAdd.bookingFieldId
          update.flowId = this.fromAdd.flowId
          update.bookingDataCustomerEmail = this.fromAdd.bookingDataCustomerEmail || ''
          update.empId = this.fromAdd.empId
          update.packageId = this.fromAdd.packageId
          update.tokenPackage = this.fromAdd.tokenPackage
          update.fieldId = d.fieldId
          update.fieldName = d.fieldName
          update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
          update.shopId = d.shopId
          update.dueDate = dueDate
          update.timeText = this.time.text
          update.sourceLink = this.source
          update.userId = userId
          update.CREATE_USER = userId || 'NotGetUserID'
          update.LAST_USER = userId || 'NotGetUserID'
          update.limitBookingCheck = limitBookingCheck
          update.limitBookingId = this.checkLimitBooking.ID
          update.limitBookingCount = this.checkLimitBooking.countBooking
          update.getLimitBooking = this.checkLimitBooking.limitBooking
          update.timeBooking = this.checkLimitBooking.timeBooking
          update.timeAll = this.checkLimitBooking.timeSelect
          update.slotByflow = this.checkLimitBooking.slotByflow
          update.timeSlotCustomer = this.fromAddTimeCus
          update.customerTimeSlot = this.customerTimeSlot
          update.statusUpload1 = this.fromAdd.statusUpload1
          update.statusUpload2 = this.fromAdd.statusUpload2
          update.fileUpload1 = ''
          update.fileUpload2 = ''
          update.dateSelect = this.date
          update.timeSelect = this.time.value
          update.bookingLanguage = this.languageSelect
          update.IsNotify = 'False'
          Add.push(update)
        } else {
          if (fielditem.filter(row => {
            return row.fieldId === parseInt(d.conditionField)
          }).length > 0
          ) {
            if (
              d.conditionValue ===
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              })[0].fieldValue
            ) {
              update.masBranchID = this.fromAdd.masBranchID
              update.bookingFieldId = this.fromAdd.bookingFieldId
              update.flowId = this.fromAdd.flowId
              update.bookingDataCustomerEmail = this.fromAdd.bookingDataCustomerEmail || ''
              update.empId = this.fromAdd.empId
              update.packageId = this.fromAdd.packageId
              update.tokenPackage = this.fromAdd.tokenPackage
              update.fieldId = d.fieldId
              update.fieldName = d.fieldName
              update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
              update.shopId = d.shopId
              update.dueDate = dueDate
              update.timeText = this.time.text
              update.sourceLink = this.source
              update.userId = userId
              update.CREATE_USER = userId || 'NotGetUserID'
              update.LAST_USER = userId || 'NotGetUserID'
              update.limitBookingCheck = limitBookingCheck
              update.limitBookingId = this.checkLimitBooking.ID
              update.limitBookingCount = this.checkLimitBooking.countBooking
              update.getLimitBooking = this.checkLimitBooking.limitBooking
              update.timeBooking = this.checkLimitBooking.timeBooking
              update.timeAll = this.checkLimitBooking.timeSelect
              update.slotByflow = this.checkLimitBooking.slotByflow
              update.timeSlotCustomer = this.fromAddTimeCus
              update.customerTimeSlot = this.customerTimeSlot
              update.statusUpload1 = this.fromAdd.statusUpload1
              update.statusUpload2 = this.fromAdd.statusUpload2
              update.fileUpload1 = ''
              update.fileUpload2 = ''
              update.dateSelect = this.date
              update.timeSelect = this.time.value
              update.bookingLanguage = this.languageSelect
              update.IsNotify = 'False'
              Add.push(update)
            }
          } else if (d.conditionField === 'flow') {
            if (parseInt(d.conditionValue) === parseInt(this.fromAdd.flowId)) {
              update.masBranchID = this.fromAdd.masBranchID
              update.bookingFieldId = this.fromAdd.bookingFieldId
              update.flowId = this.fromAdd.flowId
              update.bookingDataCustomerEmail = this.fromAdd.bookingDataCustomerEmail || ''
              update.empId = this.fromAdd.empId
              update.packageId = this.fromAdd.packageId
              update.tokenPackage = this.fromAdd.tokenPackage
              update.fieldId = d.fieldId
              update.fieldName = d.fieldName
              update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
              update.shopId = d.shopId
              update.dueDate = dueDate
              update.timeText = this.time.text
              update.sourceLink = this.source
              update.userId = userId
              update.CREATE_USER = userId || 'NotGetUserID'
              update.LAST_USER = userId || 'NotGetUserID'
              update.limitBookingCheck = limitBookingCheck
              update.limitBookingId = this.checkLimitBooking.ID
              update.limitBookingCount = this.checkLimitBooking.countBooking
              update.getLimitBooking = this.checkLimitBooking.limitBooking
              update.timeBooking = this.checkLimitBooking.timeBooking
              update.timeAll = this.checkLimitBooking.timeSelect
              update.slotByflow = this.checkLimitBooking.slotByflow
              update.timeSlotCustomer = this.fromAddTimeCus
              update.customerTimeSlot = this.customerTimeSlot
              update.statusUpload1 = this.fromAdd.statusUpload1
              update.statusUpload2 = this.fromAdd.statusUpload2
              update.fileUpload1 = ''
              update.fileUpload2 = ''
              update.dateSelect = this.date
              update.timeSelect = this.time.value
              update.bookingLanguage = this.languageSelect
              update.IsNotify = 'False'
              Add.push(update)
            }
          }
        }
      }
      console.log('Add', Add)
      this.$swal({
        title: this.languageSelect === 0 ? 'ยืนยันรายการนัดหมาย' : 'Please confirm your booking',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
        cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
      })
        .then(async result => {
          this.overlay = true
          if (await this.addbookingCheck()) {
            Add.forEach((item) => {
              item.fileUpload1 = ''
              item.statusUpload1 = 'False'
              item.fileUpload2 = ''
              item.statusUpload2 = 'False'
            })
            axios
              .post(this.$DNS_IP + '/Booking/addTimeEpm', Add)
              .then(async response => {
                if (response.data.message === 'LimitBooking_Full') {
                  this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
                  this.date = ''
                  this.time = ''
                  this.overlay = false
                } else {
                  let bookNo = response.data.bookNo
                  let flowId = this.fromAdd.flowId
                  let userId = response.data.userId
                  // console.log('response!!!!!!!!!!!', this.DataFlowNameAll.filter((item) => item.flowId === flowId))
                  await this.pushMsgLineNotifyGroup(bookNo)
                  let checkDeposit = this.DataFlowNameAll.filter((item) => item.flowId === flowId)[0].checkDeposit
                  if (this.DataFlowNameAll.filter((item) => item.flowId === flowId)[0].updateStatusConfirm === 'True' && checkDeposit !== 'True') {
                    let dtt = {
                      bookNo: bookNo,
                      contactDate: moment().format('YYYY-MM-DD HH:mm'),
                      status: 'confirm',
                      statusUse: 'use',
                      shopId: this.shopId,
                      CREATE_USER: userId,
                      LAST_USER: userId
                    }
                    await axios
                      .post(this.$DNS_IP + '/booking_transaction/add', dtt)
                      .then(async response => {
                        if (userId !== 'user-skip') {
                          await this.pushMsgConfirm(bookNo, flowId)
                        }
                        await this.resetData()
                      }).catch(error => {
                        console.log('error function booking_transaction : ', error)
                      })
                  } else {
                    if (userId !== 'user-skip') {
                      await this.pushMsgCustomer(bookNo, flowId)
                    }
                    await this.resetData()
                  }
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                }
              })
              .catch(error => {
                this.overlay = false
                console.log('error function addData : ', error)
              })
          } else {
            this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
            this.date = ''
            this.time = ''
            this.overlay = false
          }
        })
        .catch(error => {
          this.overlay = false
          console.log('Cencel : ', error)
        })
    },
    async addbookingCheck () {
      // if (this.branchData.filter(item => { return item.masBranchID === this.fromAdd.masBranchID })[0].limitBookingCheck === 'True') {
      if (this.EmpItemLimit.filter(item => { return item.empId === this.fromAdd.empId })[0].limitBookingCheck === 'True') {
        await this.checkLimit()
        // console.log('test', this.branchData.filter(item => { return item.masBranchID === this.fromAdd.masBranchID })[0].setTime)
        if (this.checkLimitBooking.limitCheck === 'true') {
          return true
        } else if (this.checkLimitBooking.limitCheck === 'false') {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    async resetData () {
      await this.$emit('resetData')
      this.internalDialog = false
    },
    async pushMsgCustomer (bookNo, flowId) {
      try {
        let updateStatusSend = {
          updateStatusSend: 'false'
        }
        axios.post(
          this.$DNS_IP + '/Booking/pushMsgCustomer/' + bookNo,
          updateStatusSend
        )
      } catch (error) {
        console.log('error', error)
      }
    },
    async pushMsgConfirm (bookNo, flowId) {
      await axios
        .post(this.$DNS_IP + '/Booking/pushMsgConfirm/' + bookNo)
        .then(async response => {
        }).catch(error => {
          console.log('error function pushMsgQueue : ', error)
        })
    },
    async pushMsgLineNotifyGroup (bookNo) {
      await axios
        .post(this.$DNS_IP + '/Booking/pushMsgLineNotifyGroupBefamily/' + bookNo)
        .then(response => {
        })
    }
  }
}
</script>
<style scoped>
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ComponentBookingListBeautyEmp/DialogAddBookingAgain.vue